import { API_URL } from '../../../app-config/constants';
import { get } from '../request';

getForCompany.operation = 'READ';
export function getForCompany(companyId) {
    return get(`${API_URL}/companies/${companyId}/emails/modifications`);
}
